import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { HStack } from '~/components/layout/Stack';
import NavigationCollapsibleTabs from '~/components/navigation/NavigationCollapsibleTabs/NavigationCollapsibleTabs';
import { useIsPayrollConsultant } from '~/hooks/useFeatureFlag';
import { RouteConfig } from '~/routes/routeConfig';
import styles from './VATBookkeepingTabs.module.scss';

const GeneralBookkeepingTabs: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation('sidebar', { keyPrefix: 'bookkeeping.submenu' });
  const isPayrollConsultant = useIsPayrollConsultant();

  return (
    <div className={styles.container}>
      <NavigationCollapsibleTabs>
        {!isPayrollConsultant && (
          <NavigationCollapsibleTabs.Tab
            label={t('transactions')}
            path={RouteConfig.GeneralBookkeepingTransactions.buildLink()}
          />
        )}
        <NavigationCollapsibleTabs.Tab
          label={t('non_electronic_documents')}
          path={RouteConfig.GeneralBookkeepingNonElectronicDocuments.buildLink()}
        />
        {!isPayrollConsultant && (
          <NavigationCollapsibleTabs.Tab
            label={t('cash_book')}
            path={RouteConfig.GeneralBookkeepingCashBook.buildLink()}
          />
        )}
        {!isPayrollConsultant && (
          <NavigationCollapsibleTabs.Tab
            label={t('ledger_cards')}
            path={RouteConfig.GeneralBookkeepingLedgerCards.buildLink()}
          />
        )}
        {!isPayrollConsultant && (
          <NavigationCollapsibleTabs.Tab
            label={t('provisional_balance')}
            path={RouteConfig.GeneralBookkeepingProvisionalBalance.buildLink()}
          />
        )}
        {!isPayrollConsultant && (
          <NavigationCollapsibleTabs.Tab
            label={t('fixed_assets')}
            path={RouteConfig.GeneralBookkeepingFixedAssets.buildLink()}
          />
        )}
      </NavigationCollapsibleTabs>

      <HStack align="center" gap={2}>
        {children}
      </HStack>
    </div>
  );
};

export default GeneralBookkeepingTabs;
